<div
  id="user-list-component"
  class="component-inner-wrapper device-configuration-list-component-class"
>
  <main class="main-content">
    <div class="container">
      <div class="breadcrumb">
        <span class="ele_link" [routerLink]="['/user-management/customers']">
          USER MANAGEMENT
        </span>
        <span>></span>
        <span>User List</span>
      </div>

      <div class="aggrid-criteria">
        <div class="grid-filter-criteria user-list-filter-row">
          <div class="user-list-title">
            <h1 class="page-title">User List</h1>
          </div>
          <div class="customer-filter">
            <label class="col-form-label me-2">Customer</label>
            <select
              class="custom-dropdown"
              [(ngModel)]="selectedCustomer"
              (change)="onHeaderCustomerChange($event)"
            >
              <option value="All">All</option>
              <option *ngFor="let item of customerList" [value]="item.customerName">
                {{ item.customerName }}
              </option>
            </select>
          </div>
        </div>
        <div class="add-user-btn-wrapper">
          <button
            type="button"
            class="btn-confirm"
            *appHasPermission="RbacPermissions.UserMgmt_UserList_Add"
            (click)="onAddUser()"
          >
            + Add User
          </button>
        </div>
      </div>

      <div class="content-wrapper content-wrapper-aggrid">
        <div
          class="component-ag-grid-wrapper user-list-grid-shell"
          [style.--mc-ag-page-size]="paginationPageSize"
          [style.--mc-ag-host-height.px]="gridHostHeightPx"
          (contextmenu)="preventDefaultContextMenu($event)"
          mcAgGridCopyCellTooltip
          style="position: relative"
        >
          <ag-grid-angular
            class="ag-theme-alpine"
            style="width: 100%"
            [rowModelType]="'infinite'"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [datasource]="dataSource"
            [cacheBlockSize]="paginationPageSize"
            [maxConcurrentDatasourceRequests]="1"
            [pagination]="true"
            [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="pageSizeOptions"
            [rowHeight]="gridRowHeightPx"
            (gridReady)="onGridReady($event)"
            (paginationChanged)="onPaginationChanged($event)"
            (filterChanged)="onGridFilterChanged()"
            (cellContextMenu)="onCellContextMenu($event)"
          >
          </ag-grid-angular>
          <div
            class="custom-context-menu"
            [ngStyle]="{
              'top.px': contextMenuPosition.y,
              'left.px': contextMenuPosition.x
            }"
            *ngIf="contextMenuVisible"
          >
            <ul>
              <li (click)="handleCopy()">Copy Value</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>

<app-roles-action-cell-renderer
  class="user-list-cell-renderer-host"
  aria-hidden="true"
></app-roles-action-cell-renderer>
<app-user-roles-cell-renderer
  class="user-list-cell-renderer-host"
  aria-hidden="true"
></app-user-roles-cell-renderer>
